export const projectDefaultIsochrone = () => {
  const isochrones: any = {
    laMeuse: {
      original: {
        type: 'FeatureCollection',
        name: 'LaMeuse',
        crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' } },
        features: [
          {
            type: 'Feature',
            // eslint-disable-next-line @typescript-eslint/camelcase
            properties: { code_insee: '55', nom: 'Meuse', nuts3: 'FR412', wikipedia: 'fr:Meuse (d�partement)' },
            geometry: {
              type: 'MultiPolygon',
              coordinates: [
                [
                  [
                    [5.464712384731442, 48.425659401071066],
                    [5.457956604637221, 48.422611497189159],
                    [5.450932228273048, 48.422845485490946],
                    [5.444178514303982, 48.428256604117131],
                    [5.438007806954307, 48.435687972657448],
                    [5.432776647560295, 48.432034203763202],
                    [5.409464557453637, 48.44474839785498],
                    [5.403381615507221, 48.454281985045029],
                    [5.406463375920922, 48.46507926018387],
                    [5.400096207018611, 48.47176066202401],
                    [5.39808973, 48.473926060584041],
                    [5.389316603272233, 48.474124794505599],
                    [5.378820148503412, 48.471543575111347],
                    [5.369168020270132, 48.476593508746042],
                    [5.368465088560309, 48.476005611432193],
                    [5.357799930181129, 48.477582413839258],
                    [5.349783723911758, 48.482169261689137],
                    [5.341565486534991, 48.494097899485404],
                    [5.338976272391574, 48.493461805671039],
                    [5.328783717683368, 48.502809468190691],
                    [5.328702420150155, 48.509516788600536],
                    [5.316711528074672, 48.508216293930289],
                    [5.305585084797095, 48.516049109055771],
                    [5.296127262159771, 48.508522971339616],
                    [5.289182566361299, 48.51091318229215],
                    [5.286211478390603, 48.515771396949333],
                    [5.270973985046782, 48.514063794046145],
                    [5.263986259946202, 48.51987521638231],
                    [5.238206587585597, 48.525819595440623],
                    [5.226783700264262, 48.532072369672463],
                    [5.22183811529907, 48.526565702278219],
                    [5.211877595428753, 48.528622391993913],
                    [5.212208983937064, 48.532274682858983],
                    [5.206486895240279, 48.536147566380009],
                    [5.208630185676661, 48.538696412597361],
                    [5.194639104789555, 48.537606215423814],
                    [5.196792725851703, 48.546677113717543],
                    [5.187729802613279, 48.549464067647115],
                    [5.186447008387557, 48.552684112134976],
                    [5.173735667454208, 48.55583961757408],
                    [5.16537998783897, 48.565271365262063],
                    [5.156102726573755, 48.563159805861872],
                    [5.152978026689473, 48.559701899070113],
                    [5.147130802673611, 48.559920689442627],
                    [5.144017511393438, 48.563229897327744],
                    [5.134473091162725, 48.570614995963155],
                    [5.12852471684587, 48.574692914370843],
                    [5.125103033928659, 48.579455092069239],
                    [5.127167452283095, 48.580441277376181],
                    [5.117659234158332, 48.585122393919043],
                    [5.121656018520436, 48.592552184094153],
                    [5.11946152411286, 48.595778159849857],
                    [5.095217431898929, 48.59289691115157],
                    [5.088463089109163, 48.593026198045465],
                    [5.081196616775919, 48.596663088188571],
                    [5.070711660442734, 48.595827115001519],
                    [5.063921115547017, 48.61106489229924],
                    [5.058729661688562, 48.615236469948762],
                    [5.057078109038708, 48.632738502274762],
                    [5.052251371185606, 48.633499477396633],
                    [5.032894832769513, 48.61339419779511],
                    [5.013949632922016, 48.610153369856242],
                    [5.006439986641363, 48.611400881011157],
                    [4.999467173574499, 48.614715390503861],
                    [4.994295302989237, 48.621539477942378],
                    [5.005643001321292, 48.633526192651097],
                    [4.994595070799549, 48.646324971909365],
                    [4.992866532529845, 48.658183265681359],
                    [4.997137752211248, 48.662879309240175],
                    [5.010598467754609, 48.668111467109227],
                    [5.007450681167525, 48.669464508659289],
                    [5.007077880324616, 48.679835216519116],
                    [4.988304168864858, 48.684336790464315],
                    [4.991289809543158, 48.686845075415285],
                    [4.989888707194518, 48.69281377404667],
                    [4.995093096793064, 48.691392098268814],
                    [5.006460647892898, 48.698839988316465],
                    [4.997006777842824, 48.709481061658479],
                    [5.001895409619001, 48.710799204615583],
                    [5.012565868058359, 48.706564806263479],
                    [5.016167753021564, 48.709863816894568],
                    [5.011183271004571, 48.718048166214381],
                    [5.004506452823824, 48.719600481786877],
                    [5.009523723348688, 48.729243595694953],
                    [5.005679472921827, 48.734920686386126],
                    [5.009160893805433, 48.741353461829831],
                    [4.989576362970229, 48.741841362028858],
                    [4.980263977577403, 48.746587300936142],
                    [4.980010383172696, 48.748728389071168],
                    [4.971608170825743, 48.757789405484566],
                    [4.964582177494058, 48.758606409822399],
                    [4.95306272127968, 48.768131382291216],
                    [4.948972601959555, 48.77042406714326],
                    [4.942986678063825, 48.778702687243829],
                    [4.93375684784561, 48.783264316780738],
                    [4.937957100619568, 48.785145306636238],
                    [4.936522221616244, 48.790046889756198],
                    [4.932544212043577, 48.789201100925425],
                    [4.935668462770217, 48.790464363642499],
                    [4.925718183694138, 48.790525794862518],
                    [4.92457489783204, 48.792241104068495],
                    [4.920819400955249, 48.789876561306748],
                    [4.921092668464679, 48.792680397017925],
                    [4.917434908290801, 48.791667111701337],
                    [4.911997765202138, 48.794821177542424],
                    [4.893582032383104, 48.79674007958431],
                    [4.893063165474996, 48.797660892164458],
                    [4.888455975877333, 48.800597603890864],
                    [4.892891946581842, 48.803761817443196],
                    [4.89076123255944, 48.805570094955307],
                    [4.897006679740753, 48.808965667863859],
                    [4.889855820584575, 48.815912700307571],
                    [4.889077789717, 48.81777288753792],
                    [4.902701279989842, 48.828115696118239],
                    [4.914715797757299, 48.835238173265587],
                    [4.934808505548729, 48.840661887805759],
                    [4.93734435976427, 48.848258688843018],
                    [4.927664922746354, 48.849682195978978],
                    [4.930229612882515, 48.856047670135084],
                    [4.922838095061723, 48.857800987309659],
                    [4.92469931449889, 48.864622175088186],
                    [4.911704016104232, 48.868411072673879],
                    [4.913364462075398, 48.872954913166929],
                    [4.918712492287875, 48.877131691650249],
                    [4.919490792650036, 48.885399200406226],
                    [4.924258780683558, 48.891169560435408],
                    [4.920158779895307, 48.894571617838068],
                    [4.912207431989453, 48.898204881383748],
                    [4.916264583138649, 48.899975264191092],
                    [4.918323970927493, 48.905351460171673],
                    [4.933115630395807, 48.91281511419389],
                    [4.932659106568416, 48.915581375587244],
                    [4.937185178295924, 48.917805986363419],
                    [4.935760090929197, 48.921935693156421],
                    [4.953785865083397, 48.931214304765135],
                    [4.959000046318539, 48.92612549722184],
                    [4.9621768484893, 48.92837017718638],
                    [4.984108407667322, 48.930837603352629],
                    [5.000403667258194, 48.93846910324536],
                    [5.01341720145312, 48.937152804263697],
                    [5.016322892071132, 48.942935893621829],
                    [5.013593989901033, 48.945947574058465],
                    [5.021491888047485, 48.947114673049555],
                    [5.022178919576779, 48.951259771842587],
                    [5.030620028975537, 48.954406683142167],
                    [5.030975582164992, 48.962753006146734],
                    [5.03877745040757, 48.975269695215538],
                    [5.029099899851749, 48.979654304435925],
                    [5.017807268246611, 48.977690110400552],
                    [5.016400596343209, 48.981760093415723],
                    [5.007387978760693, 48.978886182539192],
                    [5.004130418045891, 48.983791806257891],
                    [4.99578399107808, 48.982715707976809],
                    [4.993910015563879, 48.984302462857855],
                    [5.002197962206694, 48.987331099567925],
                    [5.000840248486275, 48.990402700799443],
                    [5.004572748491792, 48.993126881160855],
                    [5.018002651820907, 48.99616028606318],
                    [5.036062831450488, 48.99351378097009],
                    [5.039375997881378, 48.998358261950962],
                    [5.033351266765373, 48.997651016195036],
                    [5.031516727292145, 49.00150721071568],
                    [5.031245705570925, 49.006155098605319],
                    [5.03812230907086, 49.010635567471908],
                    [5.03618886508485, 49.017539179660247],
                    [5.040088272070157, 49.01783857985442],
                    [5.035683383074476, 49.020758786119103],
                    [5.035823071101157, 49.022528888873033],
                    [5.036818584099017, 49.02439506321474],
                    [5.009777587247981, 49.035430392513774],
                    [4.966893812214682, 49.021076075542204],
                    [4.965398656255794, 49.021651209011424],
                    [5.00303420390468, 49.054812198100002],
                    [5.000121326764393, 49.056148585744943],
                    [5.005404049455716, 49.060460561849531],
                    [5.003997377552312, 49.066255071693902],
                    [4.998958188134516, 49.076950473084878],
                    [4.997874819901869, 49.092165999922415],
                    [4.996785163462231, 49.106328784252732],
                    [4.985078857668756, 49.122479715914452],
                    [4.978846705553649, 49.12870668517391],
                    [4.975237005247471, 49.132992790656331],
                    [4.964621433871974, 49.154933011146682],
                    [4.951987797210703, 49.174580404830586],
                    [4.939648987625678, 49.185146781536609],
                    [4.943202902552712, 49.18822378373774],
                    [4.961072819005117, 49.198097703175129],
                    [4.977634159583143, 49.199553207684183],
                    [4.989876759601239, 49.206592276637572],
                    [4.991709682106956, 49.210656095008886],
                    [4.97745225073811, 49.219662971346885],
                    [4.970782798742693, 49.236007668345891],
                    [4.950735366041582, 49.236906900332187],
                    [4.960523229714293, 49.240313463272919],
                    [4.964485069611844, 49.247584402532304],
                    [4.999072723333241, 49.260266177623848],
                    [4.996504978925115, 49.263963770141345],
                    [5.011306699524609, 49.269486574345635],
                    [5.027145794614205, 49.274628915948135],
                    [5.032820721758572, 49.270721113455181],
                    [5.051178603073311, 49.274125871067746],
                    [5.049409101626652, 49.285607590276982],
                    [5.059244216683306, 49.289983997488797],
                    [5.056478663249615, 49.292984111868101],
                    [5.039058892586083, 49.295695517757686],
                    [5.042723479956121, 49.298612978803568],
                    [5.035821094807532, 49.307374517017749],
                    [5.02544734990652, 49.310408302958948],
                    [5.037791549383248, 49.316104280574727],
                    [5.030345234330124, 49.326176306333359],
                    [5.029261776265948, 49.326367464776872],
                    [5.02869763426752, 49.332350612334693],
                    [5.026252509895675, 49.336523790064838],
                    [5.037170094869693, 49.341859018126954],
                    [5.056220756931546, 49.358903814139808],
                    [5.053428793028501, 49.365761462489182],
                    [5.060349234314302, 49.37172841502862],
                    [5.07182799684631, 49.36940697960533],
                    [5.082663026645717, 49.372105990352381],
                    [5.088902005956983, 49.370047979558827],
                    [5.093346959814336, 49.375038987947576],
                    [5.101642991294708, 49.37837501316551],
                    [5.099041021074256, 49.385101996699774],
                    [5.104320689493611, 49.390054990060605],
                    [5.101837117227606, 49.391986979945422],
                    [5.105835877883336, 49.39328539676886],
                    [5.100427660546822, 49.391811570889416],
                    [5.085980055832327, 49.398689183078488],
                    [5.090203664803672, 49.40096439750026],
                    [5.088314687424226, 49.402312207275827],
                    [5.076992321583184, 49.403081382273669],
                    [5.091101980087792, 49.407352311509818],
                    [5.097367280036884, 49.414692777062818],
                    [5.109934261704074, 49.415625160649107],
                    [5.116242501123747, 49.421975288866022],
                    [5.10585429334666, 49.424971686654544],
                    [5.106557853877183, 49.427593676755983],
                    [5.100302165901631, 49.444713185205352],
                    [5.107413858511419, 49.444988105227907],
                    [5.10738160899272, 49.454712401966489],
                    [5.111805093114781, 49.457553989868323],
                    [5.105860312059064, 49.461590778293285],
                    [5.102483455074529, 49.460058687611912],
                    [5.100690956756597, 49.460878572279896],
                    [5.095260551032567, 49.459497687549259],
                    [5.082946894275499, 49.470599016318801],
                    [5.084859317683859, 49.480109695912894],
                    [5.079830818217945, 49.486320464944157],
                    [5.073649151421805, 49.486741393747948],
                    [5.068799147202843, 49.49578246513186],
                    [5.059229035155004, 49.500182309631008],
                    [5.0597061304024, 49.504821983352059],
                    [5.064681449603496, 49.508682102064547],
                    [5.078294609250572, 49.50894948861751],
                    [5.086089290970877, 49.520103000407659],
                    [5.089239503009227, 49.521126160420657],
                    [5.101042377695745, 49.536446798261778],
                    [5.099995481063632, 49.537156506226907],
                    [5.090990319497975, 49.534730782787314],
                    [5.088205452285677, 49.537563006730139],
                    [5.090906686345025, 49.540480873377618],
                    [5.088394008663815, 49.544915983785081],
                    [5.094571094052005, 49.549835712462901],
                    [5.097344193334082, 49.557954404723262],
                    [5.108638711401317, 49.555058385843317],
                    [5.113743388003326, 49.561960775381408],
                    [5.108247584926612, 49.561562285696994],
                    [5.112594173260352, 49.568672673180863],
                    [5.10485132433194, 49.576358410562712],
                    [5.113233683911116, 49.592327316437036],
                    [5.116050351484473, 49.590456675573883],
                    [5.1198891221881, 49.592718217974813],
                    [5.144424448217143, 49.590921081498749],
                    [5.151252902017849, 49.585390083666262],
                    [5.153142059060354, 49.576313791177135],
                    [5.153930600216754, 49.576094363396258],
                    [5.159815463643021, 49.571468092844789],
                    [5.16210931172102, 49.56707221404276],
                    [5.159776656422746, 49.566667299060711],
                    [5.162664470566606, 49.561788887409293],
                    [5.17801542113081, 49.567150283595559],
                    [5.190199630655437, 49.569923186531533],
                    [5.197542369956302, 49.566779568630352],
                    [5.208298797168349, 49.574815173576646],
                    [5.235906091974496, 49.569174571858845],
                    [5.234899889024753, 49.561912413741943],
                    [5.251970484537348, 49.556565593468399],
                    [5.263113097490038, 49.541841870858057],
                    [5.268473973611077, 49.545063916839524],
                    [5.276481017064549, 49.544339401978711],
                    [5.275243497929146, 49.541966788335138],
                    [5.284891493912118, 49.553092489235922],
                    [5.312399524879369, 49.559275990976808],
                    [5.308367167232014, 49.56270198434698],
                    [5.316767403285343, 49.567647012766209],
                    [5.318448420676516, 49.574145682588451],
                    [5.32866540956045, 49.579668694036251],
                    [5.340136985570184, 49.59413697848143],
                    [5.342729433648625, 49.594806661027846],
                    [5.344972976070713, 49.5908215039236],
                    [5.351923331255475, 49.588592601785741],
                    [5.362178857865097, 49.591982414415277],
                    [5.374565996812406, 49.591663306540156],
                    [5.379378092126378, 49.593742303424634],
                    [5.382429579315002, 49.606240387372559],
                    [5.388643315966786, 49.610525866514436],
                    [5.388398884377977, 49.61425599142887],
                    [5.394098784687244, 49.616911095547941],
                    [5.402279921642778, 49.609899998977696],
                    [5.411203695843692, 49.608279586399135],
                    [5.41797375915093, 49.599837574743681],
                    [5.425082756814867, 49.598351266103833],
                    [5.430925758748894, 49.592317883052701],
                    [5.429340232272423, 49.587832684476112],
                    [5.437664201358132, 49.569938391737828],
                    [5.457081645550489, 49.567026362687507],
                    [5.447733866535469, 49.554295615232903],
                    [5.441405594684961, 49.552427479146168],
                    [5.442763757563021, 49.550196007208051],
                    [5.465637649474085, 49.539001966857171],
                    [5.466281382206686, 49.535799167633449],
                    [5.467268451040876, 49.52596688366684],
                    [5.460959313305919, 49.525772769468205],
                    [5.455144967629455, 49.520132392136716],
                    [5.447501202876883, 49.517918165750736],
                    [5.454187453368112, 49.512626488777194],
                    [5.465713557115593, 49.509022518024047],
                    [5.464961397728199, 49.499179772885313],
                    [5.470511548879605, 49.497368107024613],
                    [5.482381707380902, 49.494288786305816],
                    [5.473871966694438, 49.482690978319567],
                    [5.463565056450564, 49.481973768051823],
                    [5.470013163559974, 49.47993127494253],
                    [5.464313712408349, 49.471109686512882],
                    [5.469178269334914, 49.465184113721378],
                    [5.464449088521666, 49.46331531559202],
                    [5.470542630588435, 49.462036908956385],
                    [5.466395288584711, 49.455491091569158],
                    [5.461104750550418, 49.453098107188843],
                    [5.46969605826468, 49.448628211711039],
                    [5.486359357627455, 49.448857497949611],
                    [5.485380014304708, 49.445423990772021],
                    [5.477781973800098, 49.436811978057456],
                    [5.480375949014521, 49.432575977443776],
                    [5.471216995872223, 49.428084988515742],
                    [5.479897775788785, 49.425021995125704],
                    [5.489236751314019, 49.426670576936139],
                    [5.491425586335304, 49.420795669986667],
                    [5.497057124851449, 49.423944704777597],
                    [5.502793406929723, 49.424486595822643],
                    [5.508259565602062, 49.420760316627728],
                    [5.50239985500375, 49.418747762763886],
                    [5.49667866462225, 49.407522404468224],
                    [5.476024509778245, 49.403406281727364],
                    [5.473042103034969, 49.410684798685274],
                    [5.457565927320157, 49.404086061701072],
                    [5.455072653249084, 49.405663507802529],
                    [5.447624990723034, 49.404150011624459],
                    [5.46569900440799, 49.395571969943788],
                    [5.474683953879754, 49.397919997744232],
                    [5.47661200797406, 49.3952090159355],
                    [5.476100956408924, 49.397282986009934],
                    [5.478522005931155, 49.393633981959255],
                    [5.473829027223857, 49.388998976548415],
                    [5.480763302565033, 49.382501596642676],
                    [5.484935527902126, 49.383467808084831],
                    [5.495811970036131, 49.392199984166972],
                    [5.498067999040669, 49.400846018096139],
                    [5.493883017626541, 49.404535989146858],
                    [5.499713982135761, 49.408770962265393],
                    [5.50556596722263, 49.40605198689947],
                    [5.527240967555508, 49.408490987879695],
                    [5.52956796346749, 49.406285973051659],
                    [5.534593947650611, 49.411249981036299],
                    [5.542448996158009, 49.411966005713118],
                    [5.55246700820651, 49.418440963766528],
                    [5.568250946737661, 49.41992000945843],
                    [5.569912021529526, 49.422151992595808],
                    [5.580002976779097, 49.42193999479084],
                    [5.578908020279283, 49.420128977314278],
                    [5.583533984666387, 49.41802897352445],
                    [5.59980696603821, 49.423874002571679],
                    [5.606843918816361, 49.418753080596261],
                    [5.605537409067137, 49.421411515569694],
                    [5.612309897825643, 49.425110400014503],
                    [5.615534310706463, 49.424722013304503],
                    [5.61710187087725, 49.420803500313951],
                    [5.616247573042052, 49.431697080228055],
                    [5.622929062462276, 49.431484188902886],
                    [5.623432658010554, 49.433758876727133],
                    [5.629269731063705, 49.433808767249332],
                    [5.634184952972294, 49.43804098126931],
                    [5.636593156585962, 49.433547513272792],
                    [5.64633870960879, 49.433464089303797],
                    [5.647081167191114, 49.429344474616407],
                    [5.665884702718304, 49.42467976795718],
                    [5.676607712601782, 49.419148877645682],
                    [5.680790358396171, 49.414318801760849],
                    [5.692345298064271, 49.416292966438355],
                    [5.691942852816986, 49.402083171079376],
                    [5.694611028873878, 49.398230374274938],
                    [5.686901507442507, 49.39375167713834],
                    [5.703445510535551, 49.38830261501942],
                    [5.707606776426178, 49.384082367624771],
                    [5.708017486174078, 49.376403768856861],
                    [5.715784948941274, 49.370938392893024],
                    [5.710637063374099, 49.365980371960511],
                    [5.712141471980415, 49.363131489110131],
                    [5.721381722655924, 49.365447370740888],
                    [5.724206385235309, 49.361367681303534],
                    [5.731375210697168, 49.361189003599065],
                    [5.738999032850433, 49.3542080127351],
                    [5.739350004631939, 49.345593977407638],
                    [5.735962996684695, 49.342917976002951],
                    [5.737063971896912, 49.338765007495752],
                    [5.719988974639425, 49.330681008004618],
                    [5.723446949494114, 49.32160397332823],
                    [5.729235962679566, 49.321689988069409],
                    [5.727140013458659, 49.318182994323763],
                    [5.731987592226352, 49.311021198861752],
                    [5.749515699713149, 49.309830188425892],
                    [5.75728801338288, 49.314566006369809],
                    [5.763138022176124, 49.316844003066542],
                    [5.762978032224021, 49.314335975551359],
                    [5.76914397850269, 49.303609010180608],
                    [5.768227966407472, 49.299607961014253],
                    [5.768680986805254, 49.296056980407215],
                    [5.762862958036125, 49.295096960244656],
                    [5.767798032712493, 49.290492974017262],
                    [5.76349402452322, 49.288060010535034],
                    [5.765360993178206, 49.285626985582908],
                    [5.761295577528394, 49.279534316287432],
                    [5.757454561036556, 49.277780873813207],
                    [5.752009961931035, 49.279876265468303],
                    [5.747417325040974, 49.277386516482871],
                    [5.748235869927863, 49.274963807481654],
                    [5.725045681205263, 49.269516761194076],
                    [5.726879861352377, 49.268025098480926],
                    [5.722861517423454, 49.264297561649769],
                    [5.730103375917912, 49.256713477210461],
                    [5.720726221993102, 49.24769887016906],
                    [5.722953684571605, 49.245641696144503],
                    [5.740070722984388, 49.230295687842606],
                    [5.738841917507242, 49.227594765776594],
                    [5.728657986625764, 49.225123792281373],
                    [5.718681297080332, 49.215988876621608],
                    [5.726848330485904, 49.201980792470096],
                    [5.723355321335134, 49.199190098656118],
                    [5.724858651963108, 49.195566082224303],
                    [5.73184574824299, 49.194371108834027],
                    [5.747446879613822, 49.19935351565821],
                    [5.750679916321368, 49.198361676502358],
                    [5.757050858147872, 49.200685895843691],
                    [5.760927447924962, 49.201596277274909],
                    [5.765572995585257, 49.197767984011648],
                    [5.755240034198144, 49.17925798130652],
                    [5.756220994488403, 49.170906013925446],
                    [5.748603999531297, 49.166664009700497],
                    [5.74434598508457, 49.156735995185173],
                    [5.750229950195553, 49.153143004729209],
                    [5.759692983061524, 49.15284900202046],
                    [5.759416751111658, 49.148898479847404],
                    [5.756113915306536, 49.142946601721505],
                    [5.771853387231123, 49.140129775794875],
                    [5.759930497622647, 49.134206467430872],
                    [5.753904149539131, 49.134154392026566],
                    [5.755205718554291, 49.128228370956272],
                    [5.747018383223297, 49.124884862754676],
                    [5.751396771918096, 49.118109859626166],
                    [5.754788810430932, 49.118452103579429],
                    [5.754971348096664, 49.114336964763019],
                    [5.760759103640718, 49.108291903036225],
                    [5.77257078181702, 49.105448878174158],
                    [5.778842549636158, 49.109298896023944],
                    [5.777401023099731, 49.111846983902851],
                    [5.808086215563855, 49.111444362734382],
                    [5.817867162208878, 49.111051911265079],
                    [5.821697398917307, 49.108328598304183],
                    [5.81579151491339, 49.102644213097761],
                    [5.819391154088387, 49.099970961972154],
                    [5.818113480259784, 49.094829906891739],
                    [5.826887684965893, 49.089975460819289],
                    [5.81935701810759, 49.086434109379084],
                    [5.816078257152083, 49.086357097651636],
                    [5.80830208072663, 49.075755696666853],
                    [5.805100125727915, 49.064816896021405],
                    [5.807123670736922, 49.060969313978099],
                    [5.823366917872843, 49.06538840441344],
                    [5.824658874914464, 49.062424199775172],
                    [5.835926892680817, 49.065823181936203],
                    [5.833561269211616, 49.060073887912452],
                    [5.836448095208663, 49.054808783645662],
                    [5.840828550028616, 49.049603587421558],
                    [5.84624566068644, 49.048798509542976],
                    [5.847864963817595, 49.044398611670289],
                    [5.853931825920424, 49.043093469875792],
                    [5.853585255883811, 49.040751371373737],
                    [5.850992268816199, 49.038052115323893],
                    [5.830509063370764, 49.032597978039647],
                    [5.82953681673876, 49.027300100277266],
                    [5.819855133932635, 49.020615103889838],
                    [5.821570377136132, 49.014562282596707],
                    [5.815816847404403, 49.010781871078251],
                    [5.813466674958089, 49.004928566478007],
                    [5.814590916536166, 49.005128570943633],
                    [5.815686861182792, 49.008383215451907],
                    [5.828272258313306, 49.006457985043312],
                    [5.820257669011448, 49.005346371003711],
                    [5.822808525092234, 49.004123885120329],
                    [5.817398061967511, 49.002046385830901],
                    [5.81184485654414, 48.993240405090944],
                    [5.80146590141448, 48.987094474610579],
                    [5.804705316160544, 48.983974916926556],
                    [5.817911718646969, 48.980389987613549],
                    [5.820238265401311, 48.976966415628794],
                    [5.826150976601386, 48.977939279722726],
                    [5.834479257600458, 48.975656203016293],
                    [5.832340728235082, 48.969774710151974],
                    [5.849245404914702, 48.961331713656115],
                    [5.847626011952019, 48.951850105668221],
                    [5.836079785942174, 48.95194378446196],
                    [5.834857358503544, 48.94494777176763],
                    [5.817033525625215, 48.942668317570877],
                    [5.799368694552175, 48.946709300692753],
                    [5.788312679192875, 48.939087616650092],
                    [5.787183317217679, 48.932746576187832],
                    [5.779981254090307, 48.934265404741794],
                    [5.776775615998927, 48.931593895104179],
                    [5.784161833759542, 48.929070910758078],
                    [5.77874732821604, 48.925186564029254],
                    [5.765650879520391, 48.922466875224238],
                    [5.755085074811634, 48.923125488282778],
                    [5.746778622873966, 48.9156928918445],
                    [5.753149834195055, 48.913134094845574],
                    [5.756765553213635, 48.9132289680242],
                    [5.757200158148093, 48.910531063490389],
                    [5.766952448535552, 48.896711767879864],
                    [5.790216209279923, 48.887021480033383],
                    [5.786526558913459, 48.878298686004022],
                    [5.777330415518398, 48.876300605868948],
                    [5.76536530509157, 48.873207500774711],
                    [5.769187546793969, 48.859967887822663],
                    [5.775099629173345, 48.857384665002343],
                    [5.777372007516053, 48.855072665641792],
                    [5.774526414190548, 48.848135376615495],
                    [5.780807973646283, 48.835019807545947],
                    [5.781943803491523, 48.828255675347059],
                    [5.779978379481398, 48.82432451722368],
                    [5.772994696799596, 48.822016196096293],
                    [5.776208779054648, 48.814984296255538],
                    [5.76929336833444, 48.804628364611489],
                    [5.757644554719148, 48.801240190057634],
                    [5.76242206489468, 48.794186616520307],
                    [5.77812003465314, 48.800001991350008],
                    [5.77617302610634, 48.790232960202069],
                    [5.767831989030233, 48.790296995736632],
                    [5.736478000837081, 48.770290971961707],
                    [5.734001974419463, 48.761070015545457],
                    [5.745215015290428, 48.758892974084745],
                    [5.741751021723334, 48.752865008863594],
                    [5.738469026832803, 48.754896975423016],
                    [5.738241034413694, 48.751649011488645],
                    [5.732446990662651, 48.748516991255769],
                    [5.7254350110494, 48.752807973552791],
                    [5.71910395442151, 48.748269994082591],
                    [5.713757002187375, 48.744589000022962],
                    [5.725752026513166, 48.737361992590081],
                    [5.71892698631054, 48.732778002730434],
                    [5.732096018881146, 48.724411691919343],
                    [5.732900011060432, 48.724079004060037],
                    [5.746332968661514, 48.716825992184184],
                    [5.737614998492191, 48.715665963257621],
                    [5.75536301356054, 48.714462994729175],
                    [5.753175975169823, 48.707895000105914],
                    [5.764654019049603, 48.701082002022254],
                    [5.756150027580957, 48.69207100905254],
                    [5.745649979550998, 48.671744966193664],
                    [5.749026028051777, 48.666953993604764],
                    [5.744623025518193, 48.657088998102139],
                    [5.742761985744082, 48.652563981229733],
                    [5.746406989840925, 48.653469990332852],
                    [5.748089983525723, 48.651431966234874],
                    [5.751066012230483, 48.641151988259757],
                    [5.756379996293693, 48.637156960959452],
                    [5.761491949249502, 48.630670014395641],
                    [5.758549966694011, 48.621252962262261],
                    [5.760467959657135, 48.621064959587208],
                    [5.765754006115008, 48.619091007990285],
                    [5.792699961208985, 48.628777007406072],
                    [5.8033936860142, 48.625134888780117],
                    [5.797989690759523, 48.613470574436718],
                    [5.790733549052048, 48.607483863285218],
                    [5.763626885353741, 48.607661759543397],
                    [5.763376794378642, 48.609748118098814],
                    [5.752079401702498, 48.606503610993663],
                    [5.743485758368498, 48.597263190892335],
                    [5.717394550267359, 48.591602300938035],
                    [5.712674801764596, 48.577590713054988],
                    [5.714132947133778, 48.573255959239162],
                    [5.71499892306767, 48.562454189247916],
                    [5.72881716809411, 48.553670581776281],
                    [5.746482717819377, 48.552402795296949],
                    [5.755470721563106, 48.546839405289241],
                    [5.762986296724636, 48.546378814623338],
                    [5.776587149452319, 48.540749576327563],
                    [5.774230509135959, 48.535300599178328],
                    [5.766481102505974, 48.535324392256143],
                    [5.761112680536548, 48.522187782334385],
                    [5.763809333187945, 48.516405782709967],
                    [5.761767103221029, 48.512533710106823],
                    [5.766042095826625, 48.504708207981615],
                    [5.765164172299454, 48.496528377058013],
                    [5.755393196954086, 48.491688201811684],
                    [5.749359123359127, 48.477412992409221],
                    [5.746157527686526, 48.476125966572596],
                    [5.742183560532637, 48.474392372391804],
                    [5.740032005595642, 48.465999116713782],
                    [5.724233873683003, 48.46339776724588],
                    [5.71909892385592, 48.460253477947596],
                    [5.695073212087558, 48.463371259861717],
                    [5.689514616772483, 48.467529116351074],
                    [5.680858630357764, 48.46824469267272],
                    [5.682188047146733, 48.470721376066059],
                    [5.678397875299976, 48.471686096198788],
                    [5.65589462827514, 48.471939214569097],
                    [5.654969812690138, 48.468526774922381],
                    [5.645733514601879, 48.471510877989701],
                    [5.642246883489626, 48.472336697198124],
                    [5.638201500270649, 48.46958278259752],
                    [5.654364617683227, 48.458782414559138],
                    [5.649487574174214, 48.455075198174953],
                    [5.63875809642069, 48.453985405704614],
                    [5.626809245500503, 48.448940491404365],
                    [5.618196018893308, 48.442305308315113],
                    [5.622142946757143, 48.425519969776957],
                    [5.615300569069534, 48.433176798425968],
                    [5.614960646566023, 48.440490762453798],
                    [5.607534004617621, 48.442560182188167],
                    [5.588736577634364, 48.442206385681786],
                    [5.580567567935166, 48.438952259972638],
                    [5.576552727435851, 48.43205280018875],
                    [5.566150416108804, 48.433934580214299],
                    [5.567414974534259, 48.439327414296194],
                    [5.560819903044367, 48.441431862477202],
                    [5.561207076931822, 48.43993677343633],
                    [5.550624833053366, 48.439933912892158],
                    [5.544314886834655, 48.4345831618799],
                    [5.532116663591595, 48.431681466428195],
                    [5.515989568621911, 48.43147797676059],
                    [5.509386861452104, 48.415936206814493],
                    [5.513707847800247, 48.410585611924134],
                    [5.50314940927682, 48.409233862016414],
                    [5.496272356619243, 48.415205583529868],
                    [5.492046322196631, 48.416666700355748],
                    [5.484996882836032, 48.415100705374371],
                    [5.47000777366827, 48.421144768399841],
                    [5.464712384731442, 48.425659401071066]
                  ],
                  [
                    [5.452565185796521, 49.412475591968992],
                    [5.451255891269917, 49.406352375114054],
                    [5.471126894849227, 49.412803877502938],
                    [5.469375988528949, 49.420624395873332],
                    [5.463875963370398, 49.414269008303627],
                    [5.452565185796521, 49.412475591968992]
                  ],
                  [
                    [5.426067310366262, 49.486102500249807],
                    [5.440772821398828, 49.486936188079255],
                    [5.455750881288595, 49.480989768119308],
                    [5.460219011680277, 49.488061579939341],
                    [5.472513534321793, 49.485709577775189],
                    [5.453598787362429, 49.494952895543236],
                    [5.442244710991858, 49.50380279912531],
                    [5.434380320005504, 49.497138989409827],
                    [5.435349512365541, 49.490768074991401],
                    [5.426067310366262, 49.486102500249807]
                  ]
                ]
              ]
            }
          }
        ]
      },
      minified: `{
        "type": "Polygon",
        "coordinates": [
          [
            [5.096969604492205, 49.602811775393874],
            [4.910888671875017, 49.17014455524007],
            [4.953460693359393, 48.97897765802537],
            [4.868316650390643, 48.806524291737915],
            [4.9918270111083975, 48.64130301939845],
            [4.989166259765643, 48.61259735567946],
            [5.508270263671892, 48.391939953034786],
            [5.775375366210956, 48.46575092367896],
            [5.846099853515643, 48.666591311338905],
            [5.77949523925783, 48.74634198451539],
            [5.871505737304705, 48.96410332613354],
            [5.874938964843768, 49.051932749595174],
            [5.797348022460955, 49.16251200210981],
            [5.774688720703143, 49.38784837359622],
            [5.556335449218768, 49.48563550325804],
            [5.413513183593768, 49.630394152969615],
            [5.096969604492205, 49.602811775393874]
          ]
        ]
      }`
    },
    valleeSud: {
      original: {
        type: 'FeatureCollection',
        name: 'Communes_VS2',
        crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' } },
        features: [
          {
            type: 'Feature',
            properties: {
              ID: 'COMMUNE_0000000009737022',
              NOM_COM: 'Bagneux',
              NOM_COM_M: 'BAGNEUX',
              INSEE_COM: '92007',
              STATUT: 'Commune simple',
              INSEE_CAN: '03',
              INSEE_ARR: '1',
              INSEE_DEP: '92',
              INSEE_REG: '11',
              CODE_EPCI: '200054781',
              POPULATION: 40918,
              TYPE: 'COM'
            },
            geometry: {
              type: 'MultiPolygon',
              coordinates: [
                [
                  [
                    [2.319077366036552, 48.810005214154522],
                    [2.317860500313392, 48.808404553455603],
                    [2.31833553487429, 48.806022969434103],
                    [2.320411997239636, 48.806127429859814],
                    [2.321027728277044, 48.805687527053422],
                    [2.321739150073866, 48.805950591460572],
                    [2.323994804403164, 48.805361673506134],
                    [2.324275648650591, 48.805859727292543],
                    [2.324442323609347, 48.805816599008978],
                    [2.32434110498795, 48.8066929363331],
                    [2.32453601007385, 48.806993535912525],
                    [2.32478627716224, 48.807014736421365],
                    [2.324759542623593, 48.807607285638298],
                    [2.325004376961318, 48.808153700414323],
                    [2.325248750258954, 48.808420400782268],
                    [2.326357396525387, 48.808296241263626],
                    [2.325982705362688, 48.806733682287422],
                    [2.323942048304942, 48.801553330347559],
                    [2.318696264868557, 48.787997409559431],
                    [2.31413595402745, 48.789379797005758],
                    [2.312446182766513, 48.789317921005214],
                    [2.311447657449273, 48.787520547690981],
                    [2.311196101329071, 48.787295144711941],
                    [2.310841847705035, 48.785776694876816],
                    [2.309697914061021, 48.784897661951447],
                    [2.306028727545445, 48.784981639671052],
                    [2.304102617875384, 48.785200687423256],
                    [2.303407207989392, 48.785397204489399],
                    [2.30311822904157, 48.78553133081865],
                    [2.301911680830818, 48.7873078224031],
                    [2.298893999695024, 48.792275583771975],
                    [2.297496152965997, 48.793678545207015],
                    [2.298315917525764, 48.794468542994281],
                    [2.296174754596995, 48.795766386931867],
                    [2.295818168325345, 48.795659056026622],
                    [2.295295938482829, 48.795620001688548],
                    [2.293467080876335, 48.795963569897616],
                    [2.292224055376508, 48.795971505022067],
                    [2.292871082007907, 48.796947591958094],
                    [2.293453505996286, 48.797568927318615],
                    [2.294583672535329, 48.798459716900219],
                    [2.299622924208903, 48.802873932755503],
                    [2.303022356511251, 48.803407359458596],
                    [2.303463474310499, 48.805346334182239],
                    [2.303822571672011, 48.806087730149819],
                    [2.304117634395331, 48.806526554724506],
                    [2.305943801490736, 48.808556313245148],
                    [2.301738929403078, 48.809979851281135],
                    [2.302689138640055, 48.811120431381063],
                    [2.317461271771384, 48.809880876218173],
                    [2.319077366036552, 48.810005214154522]
                  ]
                ]
              ]
            }
          },
          {
            type: 'Feature',
            properties: {
              ID: 'COMMUNE_0000000009736538',
              NOM_COM: 'Malakoff',
              NOM_COM_M: 'MALAKOFF',
              INSEE_COM: '92046',
              STATUT: 'Commune simple',
              INSEE_CAN: '18',
              INSEE_ARR: '1',
              INSEE_DEP: '92',
              INSEE_REG: '11',
              CODE_EPCI: '200054781',
              POPULATION: 30720,
              TYPE: 'COM'
            },
            geometry: {
              type: 'MultiPolygon',
              coordinates: [
                [
                  [
                    [2.278183329673125, 48.814248778184755],
                    [2.282601357128629, 48.815023663446759],
                    [2.285265146391211, 48.815619724331839],
                    [2.288015153094327, 48.816488753751173],
                    [2.292019146976302, 48.81819168822453],
                    [2.293393985565544, 48.818948111286375],
                    [2.295459019922782, 48.820336358052487],
                    [2.297722594809057, 48.822261766046822],
                    [2.301315418488453, 48.825125760833096],
                    [2.314145699672971, 48.822290535433098],
                    [2.307134164477289, 48.8171470029571],
                    [2.304400348094757, 48.815242414334243],
                    [2.302211185287447, 48.813459658472802],
                    [2.300097685539235, 48.811326538750862],
                    [2.299681093549511, 48.81091307663511],
                    [2.298019808367899, 48.812123809339838],
                    [2.294762156759574, 48.810533397380375],
                    [2.293833751389895, 48.811919278523241],
                    [2.293576482321337, 48.811911462893057],
                    [2.292004872154787, 48.809713940972323],
                    [2.290449955798853, 48.809702024100105],
                    [2.290437123309976, 48.808943757792569],
                    [2.288733242287701, 48.809672035974323],
                    [2.287354429371641, 48.810126113685492],
                    [2.285168880634644, 48.810621223582181],
                    [2.284814882035077, 48.810617307602207],
                    [2.283483052043807, 48.810224391744356],
                    [2.283256522946391, 48.810556709410513],
                    [2.279911190583994, 48.810917949832636],
                    [2.279966260199808, 48.810973144611559],
                    [2.278498804557997, 48.811428385216388],
                    [2.277289842423617, 48.811997594976674],
                    [2.275957252731628, 48.812445524928179],
                    [2.275390682698427, 48.812744288787272],
                    [2.274490483935192, 48.813433161476318],
                    [2.278183329673125, 48.814248778184755]
                  ]
                ]
              ]
            }
          },
          {
            type: 'Feature',
            properties: {
              ID: 'COMMUNE_0000000009736539',
              NOM_COM: 'Châtillon',
              NOM_COM_M: 'CHATILLON',
              INSEE_COM: '92020',
              STATUT: 'Commune simple',
              INSEE_CAN: '07',
              INSEE_ARR: '1',
              INSEE_DEP: '92',
              INSEE_REG: '11',
              CODE_EPCI: '200054781',
              POPULATION: 37355,
              TYPE: 'COM'
            },
            geometry: {
              type: 'MultiPolygon',
              coordinates: [
                [
                  [
                    [2.272192931339612, 48.794125236396127],
                    [2.271385654150762, 48.794906400861706],
                    [2.276375390852976, 48.797719481901744],
                    [2.275319664133165, 48.798255427088407],
                    [2.275628693023775, 48.798942647188206],
                    [2.27621863082782, 48.798813109134542],
                    [2.276474863031182, 48.799087180179889],
                    [2.276642602121391, 48.800146794355783],
                    [2.276424012147169, 48.800201234313356],
                    [2.276488362605867, 48.800469646181128],
                    [2.276676168162769, 48.800475279867555],
                    [2.277133036493422, 48.800910656816761],
                    [2.277541383257, 48.801507631044231],
                    [2.275685386324922, 48.80172304810263],
                    [2.27308574135416, 48.801858366411828],
                    [2.274344733782556, 48.803453461084978],
                    [2.276104767769206, 48.805252141240373],
                    [2.277244855155615, 48.807579488985951],
                    [2.278268109687356, 48.808713515475134],
                    [2.279911190583994, 48.810917949832636],
                    [2.283256522946391, 48.810556709410513],
                    [2.283483052043807, 48.810224391744356],
                    [2.284814882035077, 48.810617307602207],
                    [2.285168880634644, 48.810621223582181],
                    [2.287354429371641, 48.810126113685492],
                    [2.288733242287701, 48.809672035974323],
                    [2.290437123309976, 48.808943757792569],
                    [2.290449955798853, 48.809702024100105],
                    [2.292004872154787, 48.809713940972323],
                    [2.293576482321337, 48.811911462893057],
                    [2.293833751389895, 48.811919278523241],
                    [2.294762156759574, 48.810533397380375],
                    [2.298019808367899, 48.812123809339838],
                    [2.299681093549511, 48.81091307663511],
                    [2.300097685539235, 48.811326538750862],
                    [2.302689138640055, 48.811120431381063],
                    [2.301738929403078, 48.809979851281135],
                    [2.305943801490736, 48.808556313245148],
                    [2.304117634395331, 48.806526554724506],
                    [2.303822571672011, 48.806087730149819],
                    [2.303463474310499, 48.805346334182239],
                    [2.303022356511251, 48.803407359458596],
                    [2.299622924208903, 48.802873932755503],
                    [2.294583672535329, 48.798459716900219],
                    [2.293453505996286, 48.797568927318615],
                    [2.292871082007907, 48.796947591958094],
                    [2.292224055376508, 48.795971505022067],
                    [2.290119973253983, 48.795529109989481],
                    [2.289343205186866, 48.795088281583581],
                    [2.287932863574897, 48.794489876042903],
                    [2.287743585725891, 48.794992416100904],
                    [2.286547504581498, 48.796148214530703],
                    [2.285422101648471, 48.796612779869008],
                    [2.285226666334525, 48.796270736368697],
                    [2.284997292462862, 48.796219897030241],
                    [2.284481697907744, 48.795895723325188],
                    [2.282619873284654, 48.795561675366066],
                    [2.281047038697305, 48.795102520529106],
                    [2.280525420849177, 48.795020233652167],
                    [2.280252215566269, 48.795581617653696],
                    [2.279789288586052, 48.795487988762844],
                    [2.278523684182174, 48.795554106761408],
                    [2.276707670025782, 48.795945165301333],
                    [2.272192931339612, 48.794125236396127]
                  ]
                ]
              ]
            }
          },
          {
            type: 'Feature',
            properties: {
              ID: 'COMMUNE_0000000009737019',
              NOM_COM: 'Sceaux',
              NOM_COM_M: 'SCEAUX',
              INSEE_COM: '92071',
              STATUT: 'Commune simple',
              INSEE_CAN: '06',
              INSEE_ARR: '1',
              INSEE_DEP: '92',
              INSEE_REG: '11',
              CODE_EPCI: '200054781',
              POPULATION: 19344,
              TYPE: 'COM'
            },
            geometry: {
              type: 'MultiPolygon',
              coordinates: [
                [
                  [
                    [2.279475217603877, 48.782547148483907],
                    [2.280571060641436, 48.783320055138873],
                    [2.281799118590299, 48.782598015876452],
                    [2.281982973480441, 48.783182842503294],
                    [2.282415495109792, 48.783005557495478],
                    [2.282560889581149, 48.783022620100702],
                    [2.283155404783425, 48.782842707316782],
                    [2.284299274734792, 48.782698462444678],
                    [2.285267244369759, 48.782478502953651],
                    [2.287644296520576, 48.782524178081047],
                    [2.289060550732866, 48.782964333203289],
                    [2.290016576148524, 48.783220954848751],
                    [2.290093607099992, 48.783161151675429],
                    [2.290709729301039, 48.783392362902973],
                    [2.291557824645934, 48.783579975711632],
                    [2.29147814480178, 48.783834937227873],
                    [2.293166805001118, 48.784165130298518],
                    [2.303407207989392, 48.785397204489399],
                    [2.304102617875384, 48.785200687423256],
                    [2.306028727545445, 48.784981639671052],
                    [2.309697914061021, 48.784897661951447],
                    [2.31047110607535, 48.784889534480754],
                    [2.310160435735341, 48.784195193421368],
                    [2.310099698128928, 48.784259600492227],
                    [2.309302159378249, 48.782920263083817],
                    [2.309385888997159, 48.782866782211791],
                    [2.306851637602414, 48.77836222142475],
                    [2.307445335628537, 48.77823344994367],
                    [2.306911209804059, 48.777463148630964],
                    [2.310576614195722, 48.776904231459753],
                    [2.312068753552152, 48.77654586990586],
                    [2.314253496344108, 48.776812066211725],
                    [2.31239901250605, 48.772137012230786],
                    [2.311831638180712, 48.770688372300661],
                    [2.310856631244987, 48.770848245369422],
                    [2.309262209133946, 48.770927179988192],
                    [2.307434379643458, 48.770752901674889],
                    [2.307404338834442, 48.770248150539913],
                    [2.307164879436447, 48.769631555459306],
                    [2.306893437684423, 48.769374544065215],
                    [2.306576919732311, 48.769233296183728],
                    [2.290254897776367, 48.766600144563476],
                    [2.286285710933607, 48.771302086012739],
                    [2.286222082030233, 48.772870303175708],
                    [2.286440022081373, 48.773351897723302],
                    [2.287013435490351, 48.773711493272025],
                    [2.286303809973161, 48.774157867146151],
                    [2.285252086617691, 48.774245119378655],
                    [2.285068923357679, 48.774404120749878],
                    [2.284545351814668, 48.774280463548862],
                    [2.283186701872476, 48.774322686748917],
                    [2.282527688043897, 48.774450046534952],
                    [2.282709590079548, 48.774779428416558],
                    [2.281480727934023, 48.774486926498909],
                    [2.280134575261626, 48.773918481275899],
                    [2.279144572363299, 48.77505388052824],
                    [2.278659307897951, 48.775998943466178],
                    [2.278299201724132, 48.776453675324589],
                    [2.280112414738961, 48.779076534302035],
                    [2.280440406692476, 48.78016141151835],
                    [2.279943063880727, 48.782078673971675],
                    [2.27977341159967, 48.782340281438152],
                    [2.279475217603877, 48.782547148483907]
                  ]
                ]
              ]
            }
          },
          {
            type: 'Feature',
            properties: {
              ID: 'COMMUNE_0000000009737023',
              NOM_COM: 'Antony',
              NOM_COM_M: 'ANTONY',
              INSEE_COM: '92002',
              STATUT: 'Sous-préfecture',
              INSEE_CAN: '01',
              INSEE_ARR: '1',
              INSEE_DEP: '92',
              INSEE_REG: '11',
              CODE_EPCI: '200054781',
              POPULATION: 62570,
              TYPE: 'COM'
            },
            geometry: {
              type: 'MultiPolygon',
              coordinates: [
                [
                  [
                    [2.31239901250605, 48.772137012230786],
                    [2.319920413368245, 48.770730199761836],
                    [2.317721821519392, 48.768522168984028],
                    [2.317222313632664, 48.768325938501832],
                    [2.316499269090667, 48.767328837759869],
                    [2.315878036608499, 48.766766737757955],
                    [2.31566812045885, 48.76679611578151],
                    [2.315407008229337, 48.766060687440181],
                    [2.315299778824474, 48.766041184844227],
                    [2.315102913544004, 48.765698273897144],
                    [2.315086286261129, 48.765513795966555],
                    [2.315374309726633, 48.765441694170661],
                    [2.315278595353844, 48.764855618149504],
                    [2.314787154088925, 48.763840943049644],
                    [2.314368456641055, 48.762054072328134],
                    [2.313617145538904, 48.762286307076153],
                    [2.313102585860492, 48.761585390909168],
                    [2.313385255497475, 48.760160518515335],
                    [2.312587554524035, 48.759371625026176],
                    [2.312706610655972, 48.759318344293249],
                    [2.308693502687006, 48.755409625559366],
                    [2.311463710297235, 48.754329217448586],
                    [2.31089311905597, 48.753759281009025],
                    [2.311625152731628, 48.753020568018371],
                    [2.310119445923488, 48.752191591269849],
                    [2.312346291520355, 48.751351768232226],
                    [2.314144562530241, 48.751344121806405],
                    [2.317035825350216, 48.750030423596961],
                    [2.317054344001884, 48.750174439785525],
                    [2.317666851360478, 48.750141064452208],
                    [2.318586020172452, 48.74974696241032],
                    [2.319307055462621, 48.749630550121211],
                    [2.320031867605258, 48.749014966046062],
                    [2.32072071416347, 48.748758049301493],
                    [2.31931663387029, 48.74712206571175],
                    [2.320465784551204, 48.746817404698461],
                    [2.318476118910919, 48.745036861294224],
                    [2.317553007403577, 48.744490123569605],
                    [2.317201801565234, 48.744722870307569],
                    [2.316363764523346, 48.744119944673912],
                    [2.316166672657745, 48.744319391945353],
                    [2.31434409938316, 48.743296164693511],
                    [2.317031556921274, 48.740893859230894],
                    [2.315552405392175, 48.739926577823823],
                    [2.315637431255233, 48.739872198986063],
                    [2.315419039640109, 48.739622699361043],
                    [2.314170643208258, 48.738899573477937],
                    [2.314315165864727, 48.738767285329885],
                    [2.313029417163519, 48.738198637433179],
                    [2.3146026808789, 48.736857607308394],
                    [2.318160164101557, 48.737882664331444],
                    [2.318718087902937, 48.737018780993061],
                    [2.317322677083986, 48.735580683791021],
                    [2.316670049723929, 48.734536284963596],
                    [2.316481951512632, 48.733843529756086],
                    [2.315287621986526, 48.733672984568493],
                    [2.31542250762709, 48.733340960893045],
                    [2.314442400735643, 48.730421106182504],
                    [2.314216715150672, 48.730316372408353],
                    [2.312858312052329, 48.730222212216709],
                    [2.307919372299836, 48.729353585011104],
                    [2.303840060837942, 48.72948996496163],
                    [2.302956889350414, 48.732299206807653],
                    [2.301779826613733, 48.735013174162134],
                    [2.30154725997169, 48.736236867209719],
                    [2.302454557187072, 48.740795186490729],
                    [2.301695586322456, 48.740296952466778],
                    [2.299644793662199, 48.73918581249464],
                    [2.297333131881807, 48.738165743897611],
                    [2.29537378990461, 48.73754616615458],
                    [2.293978882689982, 48.73692180017342],
                    [2.28963792427327, 48.735553164417311],
                    [2.282136240321863, 48.733854189958855],
                    [2.281272585858337, 48.73357375949184],
                    [2.280718758684975, 48.733307782413533],
                    [2.279883437612638, 48.732748680933852],
                    [2.279276552764312, 48.733372838565856],
                    [2.278787661540186, 48.734116433964935],
                    [2.278021216698913, 48.734673960284823],
                    [2.277294593480575, 48.735497061742691],
                    [2.275359785249413, 48.738425646140563],
                    [2.275175578494225, 48.739058641692061],
                    [2.275381748507634, 48.739586972051583],
                    [2.275095518962484, 48.73992792536891],
                    [2.274821276941025, 48.740090859403665],
                    [2.27455309975207, 48.740698158440381],
                    [2.275124889493218, 48.740849141532685],
                    [2.275777247124209, 48.740682205119363],
                    [2.276234291737954, 48.740772223553535],
                    [2.276953514875232, 48.741668836254853],
                    [2.277290142588004, 48.741714947567516],
                    [2.277426680019938, 48.741872278269994],
                    [2.278328536901804, 48.742349044711041],
                    [2.27874697226209, 48.742380355702522],
                    [2.278805023057288, 48.742608266981577],
                    [2.279036750970561, 48.742668130746054],
                    [2.279115591941557, 48.742769345089023],
                    [2.279423143213877, 48.742755011655881],
                    [2.279370750574691, 48.743003842693142],
                    [2.279669536100237, 48.743033528685991],
                    [2.279775807319009, 48.743216757846298],
                    [2.279972682591859, 48.743141492238649],
                    [2.280482087315491, 48.743578996779704],
                    [2.280820793762204, 48.743672781233208],
                    [2.28107821999953, 48.743644649849422],
                    [2.281133205543868, 48.74379968595656],
                    [2.281433183254127, 48.743841966927498],
                    [2.281524503505259, 48.744025104371453],
                    [2.281875922589449, 48.744282661683172],
                    [2.282295500835025, 48.744429995637212],
                    [2.282388296277589, 48.744605046148102],
                    [2.282807988535461, 48.744645344745905],
                    [2.283044306997749, 48.744867128536377],
                    [2.283356864865048, 48.744885195072612],
                    [2.284827637052453, 48.745636956686752],
                    [2.284119984579589, 48.746164288238553],
                    [2.285358224042771, 48.7475127784516],
                    [2.283964862542807, 48.748649422991477],
                    [2.283951019117711, 48.748766267643489],
                    [2.283629160392957, 48.749027873992191],
                    [2.282408569600558, 48.74985972521624],
                    [2.281983430078377, 48.750509265425265],
                    [2.282079227268979, 48.750763484162562],
                    [2.281431744748529, 48.751062701514584],
                    [2.28045561527688, 48.752310645087476],
                    [2.279639381213194, 48.753008187261109],
                    [2.278232067572383, 48.753560040832689],
                    [2.277274838218322, 48.753826781715929],
                    [2.277404208216453, 48.754012849308552],
                    [2.276024782962357, 48.754511778490844],
                    [2.275058062106569, 48.755166102503438],
                    [2.275002455966337, 48.755252111115276],
                    [2.276121999838043, 48.756624250777868],
                    [2.277114034685763, 48.757875981063528],
                    [2.277720153368707, 48.759001245925582],
                    [2.27858645975215, 48.760004855758666],
                    [2.280650770983614, 48.760162116421917],
                    [2.28400045542097, 48.760634660763756],
                    [2.284806511575203, 48.760684462127308],
                    [2.286361806440646, 48.760661385991732],
                    [2.288102828742778, 48.760486493059396],
                    [2.288173621324958, 48.761081440720453],
                    [2.290829788586088, 48.760938941909338],
                    [2.291939321212576, 48.764492884198653],
                    [2.290254897776367, 48.766600144563476],
                    [2.306576919732311, 48.769233296183728],
                    [2.306893437684423, 48.769374544065215],
                    [2.307164879436447, 48.769631555459306],
                    [2.307404338834442, 48.770248150539913],
                    [2.307434379643458, 48.770752901674889],
                    [2.309262209133946, 48.770927179988192],
                    [2.310856631244987, 48.770848245369422],
                    [2.311831638180712, 48.770688372300661],
                    [2.31239901250605, 48.772137012230786]
                  ]
                ]
              ]
            }
          },
          {
            type: 'Feature',
            properties: {
              ID: 'COMMUNE_0000000009737026',
              NOM_COM: 'Châtenay-Malabry',
              NOM_COM_M: 'CHATENAY MALABRY',
              INSEE_COM: '92019',
              STATUT: 'Commune simple',
              INSEE_CAN: '06',
              INSEE_ARR: '1',
              INSEE_DEP: '92',
              INSEE_REG: '11',
              CODE_EPCI: '200054781',
              POPULATION: 33286,
              TYPE: 'COM'
            },
            geometry: {
              type: 'MultiPolygon',
              coordinates: [
                [
                  [
                    [2.23285361678427, 48.765986233978055],
                    [2.232602565822912, 48.766034090252091],
                    [2.232818109677495, 48.766272925834528],
                    [2.232691591772896, 48.767845224523946],
                    [2.233124661200065, 48.769115307605368],
                    [2.232817434997496, 48.769929120366882],
                    [2.231793152289859, 48.771017146497854],
                    [2.230760365374334, 48.771202079245988],
                    [2.23055667768695, 48.771358167961772],
                    [2.230406569299293, 48.771940931963506],
                    [2.230740828929338, 48.773266147353695],
                    [2.230620815653435, 48.773745670050545],
                    [2.230213060210441, 48.774082128232649],
                    [2.228843879378716, 48.774465449007117],
                    [2.228757428265271, 48.775527116508734],
                    [2.228911333942625, 48.775978723580302],
                    [2.229321411483678, 48.776315956885377],
                    [2.230385272022081, 48.776799511615636],
                    [2.237455504466116, 48.776297097547051],
                    [2.237165807560502, 48.775820350558092],
                    [2.237235314900264, 48.775533876999759],
                    [2.236486920733896, 48.774971451038581],
                    [2.236807367040915, 48.773716996903467],
                    [2.237255266230457, 48.77361012716014],
                    [2.238244072571361, 48.773829601094057],
                    [2.238499067244211, 48.773793450796276],
                    [2.238735988194096, 48.773223823368674],
                    [2.239023894157681, 48.773263433728694],
                    [2.239195955533968, 48.772661911956817],
                    [2.240653203073, 48.773044447037819],
                    [2.242058627391159, 48.773061467173093],
                    [2.241918158186066, 48.773832285692421],
                    [2.242685293017275, 48.773387437050353],
                    [2.243838398541419, 48.773069148322747],
                    [2.244420590426329, 48.772990084618733],
                    [2.24494716906707, 48.772804533986161],
                    [2.244939676301225, 48.772852156357651],
                    [2.246320091954513, 48.772716065425968],
                    [2.246471902385538, 48.773511218460811],
                    [2.249850855307094, 48.773027905001776],
                    [2.25072205640999, 48.772816610324035],
                    [2.2508641253931, 48.772683486511013],
                    [2.25129289939786, 48.772579142627691],
                    [2.252318685787448, 48.7725945615828],
                    [2.254070392522063, 48.772755716923143],
                    [2.25412640461748, 48.773025895008374],
                    [2.255714030702404, 48.773052886218089],
                    [2.25570731950999, 48.773237227033434],
                    [2.256492426283086, 48.77324121657432],
                    [2.256565037577113, 48.773111251509668],
                    [2.257220965812277, 48.773299714306049],
                    [2.259333835870872, 48.773136545212964],
                    [2.259916315965811, 48.773227399631402],
                    [2.26380378616833, 48.774595162403863],
                    [2.264310062327774, 48.77459108584339],
                    [2.264397251878037, 48.774680665856188],
                    [2.264287517677918, 48.774935426884127],
                    [2.264556161935374, 48.774991945927248],
                    [2.264732294867147, 48.774853619204798],
                    [2.264966331898145, 48.775048435782566],
                    [2.265098351860202, 48.774950311237802],
                    [2.265917203656938, 48.775556161383157],
                    [2.266386548845087, 48.775275725703622],
                    [2.267228735600964, 48.775287190384503],
                    [2.267070766827625, 48.775682867507079],
                    [2.267288033117276, 48.775909955695951],
                    [2.26725197906949, 48.776151679610436],
                    [2.267402910353669, 48.776451213918193],
                    [2.269332364022728, 48.775981838359087],
                    [2.269555905005916, 48.776344773623947],
                    [2.269887763597756, 48.776552770130635],
                    [2.271689136669199, 48.776971203872399],
                    [2.272386191725841, 48.777340616757506],
                    [2.274392605985353, 48.777011938515955],
                    [2.275061657466364, 48.779496604334412],
                    [2.275377528740945, 48.779486828045179],
                    [2.27585244671454, 48.780765084793529],
                    [2.276226024609285, 48.781305201020722],
                    [2.276284502943734, 48.78121021684661],
                    [2.276440342412156, 48.781356866549764],
                    [2.277508098695573, 48.781106094204368],
                    [2.278093239395738, 48.782095393698953],
                    [2.278274945797773, 48.782045224593375],
                    [2.278975645346166, 48.782750101465496],
                    [2.279475217603877, 48.782547148483907],
                    [2.27977341159967, 48.782340281438152],
                    [2.279943063880727, 48.782078673971675],
                    [2.280440406692476, 48.78016141151835],
                    [2.280112414738961, 48.779076534302035],
                    [2.278299201724132, 48.776453675324589],
                    [2.278659307897951, 48.775998943466178],
                    [2.279144572363299, 48.77505388052824],
                    [2.280134575261626, 48.773918481275899],
                    [2.281480727934023, 48.774486926498909],
                    [2.282709590079548, 48.774779428416558],
                    [2.282527688043897, 48.774450046534952],
                    [2.283186701872476, 48.774322686748917],
                    [2.284545351814668, 48.774280463548862],
                    [2.285068923357679, 48.774404120749878],
                    [2.285252086617691, 48.774245119378655],
                    [2.286303809973161, 48.774157867146151],
                    [2.287013435490351, 48.773711493272025],
                    [2.286440022081373, 48.773351897723302],
                    [2.286222082030233, 48.772870303175708],
                    [2.286285710933607, 48.771302086012739],
                    [2.290254897776367, 48.766600144563476],
                    [2.291939321212576, 48.764492884198653],
                    [2.290829788586088, 48.760938941909338],
                    [2.288173621324958, 48.761081440720453],
                    [2.288102828742778, 48.760486493059396],
                    [2.286361806440646, 48.760661385991732],
                    [2.284806511575203, 48.760684462127308],
                    [2.28400045542097, 48.760634660763756],
                    [2.280650770983614, 48.760162116421917],
                    [2.27858645975215, 48.760004855758666],
                    [2.277720153368707, 48.759001245925582],
                    [2.277114034685763, 48.757875981063528],
                    [2.276121999838043, 48.756624250777868],
                    [2.275315688510679, 48.756891890348889],
                    [2.271415402350211, 48.757782887334109],
                    [2.27062146074969, 48.757843699971126],
                    [2.269432450065207, 48.757652946855636],
                    [2.270384884836202, 48.759391985309627],
                    [2.270916216813251, 48.760700311967341],
                    [2.268683737266666, 48.760700154158691],
                    [2.268982657734552, 48.76179569759308],
                    [2.268881412260618, 48.762030729793253],
                    [2.267167187774805, 48.76232333338605],
                    [2.264926479649767, 48.761453301342513],
                    [2.262371939941715, 48.760076704225902],
                    [2.26200189885993, 48.759788397169345],
                    [2.259392949259162, 48.761011671218064],
                    [2.258910154038165, 48.761095921736363],
                    [2.25501234202061, 48.761390072381687],
                    [2.254456762045329, 48.76114015982121],
                    [2.253147405410527, 48.76108700724852],
                    [2.251450532323601, 48.760734597749462],
                    [2.250277546830712, 48.761322667808905],
                    [2.250182925399877, 48.761469581509424],
                    [2.2493312973906, 48.761846492616165],
                    [2.247008759135448, 48.760823602705869],
                    [2.24523989366536, 48.762631099971969],
                    [2.240702459604669, 48.763766211284988],
                    [2.238586808776485, 48.766473535597356],
                    [2.232974391836455, 48.766192980339952],
                    [2.23285361678427, 48.765986233978055]
                  ]
                ]
              ]
            }
          },
          {
            type: 'Feature',
            properties: {
              ID: 'COMMUNE_0000000009737020',
              NOM_COM: 'Fontenay-aux-Roses',
              NOM_COM_M: 'FONTENAY AUX ROSES',
              INSEE_COM: '92032',
              STATUT: 'Commune simple',
              INSEE_CAN: '07',
              INSEE_ARR: '1',
              INSEE_DEP: '92',
              INSEE_REG: '11',
              CODE_EPCI: '200054781',
              POPULATION: 24564,
              TYPE: 'COM'
            },
            geometry: {
              type: 'MultiPolygon',
              coordinates: [
                [
                  [
                    [2.271721900552649, 48.79051842856213],
                    [2.272319681538355, 48.79079639071665],
                    [2.272988895855532, 48.79083284265144],
                    [2.272192931339612, 48.794125236396127],
                    [2.276707670025782, 48.795945165301333],
                    [2.278523684182174, 48.795554106761408],
                    [2.279789288586052, 48.795487988762844],
                    [2.280252215566269, 48.795581617653696],
                    [2.280525420849177, 48.795020233652167],
                    [2.281047038697305, 48.795102520529106],
                    [2.282619873284654, 48.795561675366066],
                    [2.284481697907744, 48.795895723325188],
                    [2.284997292462862, 48.796219897030241],
                    [2.285226666334525, 48.796270736368697],
                    [2.285422101648471, 48.796612779869008],
                    [2.286547504581498, 48.796148214530703],
                    [2.287743585725891, 48.794992416100904],
                    [2.287932863574897, 48.794489876042903],
                    [2.289343205186866, 48.795088281583581],
                    [2.290119973253983, 48.795529109989481],
                    [2.292224055376508, 48.795971505022067],
                    [2.293467080876335, 48.795963569897616],
                    [2.295295938482829, 48.795620001688548],
                    [2.295818168325345, 48.795659056026622],
                    [2.296174754596995, 48.795766386931867],
                    [2.298315917525764, 48.794468542994281],
                    [2.297496152965997, 48.793678545207015],
                    [2.298893999695024, 48.792275583771975],
                    [2.301911680830818, 48.7873078224031],
                    [2.30311822904157, 48.78553133081865],
                    [2.303407207989392, 48.785397204489399],
                    [2.293166805001118, 48.784165130298518],
                    [2.29147814480178, 48.783834937227873],
                    [2.291557824645934, 48.783579975711632],
                    [2.290709729301039, 48.783392362902973],
                    [2.290093607099992, 48.783161151675429],
                    [2.290016576148524, 48.783220954848751],
                    [2.289060550732866, 48.782964333203289],
                    [2.287644296520576, 48.782524178081047],
                    [2.285267244369759, 48.782478502953651],
                    [2.284299274734792, 48.782698462444678],
                    [2.283155404783425, 48.782842707316782],
                    [2.282560889581149, 48.783022620100702],
                    [2.282415495109792, 48.783005557495478],
                    [2.281982973480441, 48.783182842503294],
                    [2.281853105144182, 48.783224334608335],
                    [2.281890083849051, 48.783405339611271],
                    [2.281319859537486, 48.783401911194694],
                    [2.280877150011106, 48.783527864155573],
                    [2.280801547812407, 48.783878181553803],
                    [2.279915462539166, 48.784078811209767],
                    [2.279532717084509, 48.784099888821238],
                    [2.279477589357958, 48.784050987924914],
                    [2.278753298611939, 48.784263377504161],
                    [2.279097066633943, 48.785191850385509],
                    [2.280151213171646, 48.785044405544092],
                    [2.280190662153742, 48.785539321608773],
                    [2.278421030209807, 48.785653666996403],
                    [2.277250289427032, 48.785963185570132],
                    [2.276607907269483, 48.786057334617894],
                    [2.275950576215922, 48.78605155456178],
                    [2.275605360385358, 48.785917248221622],
                    [2.274764875273899, 48.785770941761591],
                    [2.273982032103238, 48.786373293189868],
                    [2.273828652141533, 48.786733925996927],
                    [2.273993290899463, 48.787716187539232],
                    [2.274824269794296, 48.78756923236358],
                    [2.274965565248343, 48.787686114158156],
                    [2.274492659192621, 48.787924286817251],
                    [2.27353389508323, 48.788156806615724],
                    [2.27302678917303, 48.788406457900059],
                    [2.272282623322328, 48.788964061790303],
                    [2.272067449544311, 48.789166918032166],
                    [2.272025097484228, 48.789665834193016],
                    [2.271721900552649, 48.79051842856213]
                  ]
                ]
              ]
            }
          },
          {
            type: 'Feature',
            properties: {
              ID: 'COMMUNE_0000000009737021',
              NOM_COM: 'Bourg-la-Reine',
              NOM_COM_M: 'BOURG LA REINE',
              INSEE_COM: '92014',
              STATUT: 'Commune simple',
              INSEE_CAN: '03',
              INSEE_ARR: '1',
              INSEE_DEP: '92',
              INSEE_REG: '11',
              CODE_EPCI: '200054781',
              POPULATION: 20667,
              TYPE: 'COM'
            },
            geometry: {
              type: 'MultiPolygon',
              coordinates: [
                [
                  [
                    [2.319920413368245, 48.770730199761836],
                    [2.31239901250605, 48.772137012230786],
                    [2.314253496344108, 48.776812066211725],
                    [2.312068753552152, 48.77654586990586],
                    [2.310576614195722, 48.776904231459753],
                    [2.306911209804059, 48.777463148630964],
                    [2.307445335628537, 48.77823344994367],
                    [2.306851637602414, 48.77836222142475],
                    [2.309385888997159, 48.782866782211791],
                    [2.309302159378249, 48.782920263083817],
                    [2.310099698128928, 48.784259600492227],
                    [2.310160435735341, 48.784195193421368],
                    [2.31047110607535, 48.784889534480754],
                    [2.309697914061021, 48.784897661951447],
                    [2.310841847705035, 48.785776694876816],
                    [2.311196101329071, 48.787295144711941],
                    [2.311447657449273, 48.787520547690981],
                    [2.312446182766513, 48.789317921005214],
                    [2.31413595402745, 48.789379797005758],
                    [2.318696264868557, 48.787997409559431],
                    [2.322083238225995, 48.787020126633443],
                    [2.325119460401384, 48.786316885991553],
                    [2.324736288622472, 48.784478124548016],
                    [2.32490562843942, 48.78443411084244],
                    [2.324372931158676, 48.783318527371769],
                    [2.324836843076726, 48.783228510163852],
                    [2.324444038799042, 48.782241432854889],
                    [2.325814779843311, 48.781908297517631],
                    [2.324844095697518, 48.77993309921164],
                    [2.325036368700886, 48.779903605460909],
                    [2.324580300699613, 48.779074465364758],
                    [2.326616564169431, 48.778731589645652],
                    [2.325724801074371, 48.777075231375626],
                    [2.325028499314539, 48.777250283547659],
                    [2.324242563012695, 48.776359914394064],
                    [2.323740234620707, 48.776583725302672],
                    [2.32171851103605, 48.773614074601362],
                    [2.320558853276971, 48.771440778814046],
                    [2.319920413368245, 48.770730199761836]
                  ]
                ]
              ]
            }
          },
          {
            type: 'Feature',
            properties: {
              ID: 'COMMUNE_0000000009736537',
              NOM_COM: 'Montrouge',
              NOM_COM_M: 'MONTROUGE',
              INSEE_COM: '92049',
              STATUT: 'Commune simple',
              INSEE_CAN: '18',
              INSEE_ARR: '1',
              INSEE_DEP: '92',
              INSEE_REG: '11',
              CODE_EPCI: '200054781',
              POPULATION: 50260,
              TYPE: 'COM'
            },
            geometry: {
              type: 'MultiPolygon',
              coordinates: [
                [
                  [
                    [2.302689138640055, 48.811120431381063],
                    [2.300097685539235, 48.811326538750862],
                    [2.302211185287447, 48.813459658472802],
                    [2.304400348094757, 48.815242414334243],
                    [2.307134164477289, 48.8171470029571],
                    [2.314145699672971, 48.822290535433098],
                    [2.332461042459754, 48.818247130074461],
                    [2.331898060637624, 48.817010929633305],
                    [2.329063257287334, 48.813783346790586],
                    [2.325557826171094, 48.809580561711009],
                    [2.321885923102822, 48.809742366550282],
                    [2.319077366036552, 48.810005214154522],
                    [2.317461271771384, 48.809880876218173],
                    [2.302689138640055, 48.811120431381063]
                  ]
                ]
              ]
            }
          },
          {
            type: 'Feature',
            properties: {
              ID: 'COMMUNE_0000000009737025',
              NOM_COM: 'Clamart',
              NOM_COM_M: 'CLAMART',
              INSEE_COM: '92023',
              STATUT: 'Commune simple',
              INSEE_CAN: '08',
              INSEE_ARR: '1',
              INSEE_DEP: '92',
              INSEE_REG: '11',
              CODE_EPCI: '200054781',
              POPULATION: 52971,
              TYPE: 'COM'
            },
            geometry: {
              type: 'MultiPolygon',
              coordinates: [
                [
                  [
                    [2.226553884283135, 48.776101996384135],
                    [2.225623739189815, 48.776331621126197],
                    [2.224953163064658, 48.776676250796079],
                    [2.224566108539205, 48.777447247078399],
                    [2.224104988135958, 48.777798627648089],
                    [2.223979035753998, 48.778215143777885],
                    [2.224250092035868, 48.779206273265061],
                    [2.224033906188002, 48.779741826668968],
                    [2.224018389203363, 48.780144668549916],
                    [2.223645785079408, 48.780582066944838],
                    [2.223689756055463, 48.780645312410726],
                    [2.224802688997497, 48.780851311394557],
                    [2.226615567033259, 48.78158169986812],
                    [2.228139732521262, 48.782235543163885],
                    [2.229697666645812, 48.783093753021625],
                    [2.232908856031506, 48.784076793279048],
                    [2.234847092981064, 48.784534434178099],
                    [2.235415808326386, 48.786963809673033],
                    [2.235632118208821, 48.787342949355619],
                    [2.235849963263196, 48.788268044990083],
                    [2.236371943324446, 48.78878135145839],
                    [2.236516767377812, 48.788744501315861],
                    [2.236611986443898, 48.788934886662062],
                    [2.236455431156926, 48.789029224650982],
                    [2.234789457571507, 48.79542509898711],
                    [2.236063835577842, 48.795600542258292],
                    [2.238764587687424, 48.797758372443347],
                    [2.238953990170548, 48.798493496813222],
                    [2.239600400940297, 48.799632664873421],
                    [2.240064707515171, 48.799629321983971],
                    [2.240592129108606, 48.80071466168846],
                    [2.24078694793131, 48.800799544178389],
                    [2.241081225108226, 48.800786123089203],
                    [2.241577823762982, 48.800903499842512],
                    [2.241805932103643, 48.801601987249349],
                    [2.241387413465719, 48.801825982194096],
                    [2.241030834099277, 48.801910061582106],
                    [2.241573207672121, 48.802906448296746],
                    [2.242345580712239, 48.803442894940204],
                    [2.242755456554548, 48.803252120140101],
                    [2.243422563949248, 48.803912909877816],
                    [2.245093610142294, 48.804732039022198],
                    [2.245726258113732, 48.804295324872676],
                    [2.246234549529149, 48.804643002758873],
                    [2.246284049928264, 48.80479801228968],
                    [2.248251771888092, 48.803932585321171],
                    [2.248420708772383, 48.804019990411774],
                    [2.248899197763826, 48.804641787605966],
                    [2.249211152994381, 48.805671764808935],
                    [2.249558240332136, 48.805585802825718],
                    [2.249278952135202, 48.80606972642061],
                    [2.248575928242446, 48.806477235418171],
                    [2.248277191401094, 48.807459302452394],
                    [2.25033768354157, 48.8078176115907],
                    [2.251613914325368, 48.808647659778686],
                    [2.252659543699711, 48.809608463770388],
                    [2.25312705350004, 48.80976788083079],
                    [2.255000924005436, 48.810139332410458],
                    [2.254696842079416, 48.81093070608037],
                    [2.254564119466155, 48.812403990412172],
                    [2.25408197805463, 48.813455974902105],
                    [2.253644919145499, 48.814116101772633],
                    [2.254341318232301, 48.814271545440533],
                    [2.253440490180588, 48.815078077339685],
                    [2.252633214143438, 48.815531724992461],
                    [2.252066775485944, 48.815999465424284],
                    [2.251866495297641, 48.816384951715641],
                    [2.253256283049125, 48.816529448168097],
                    [2.253557622019619, 48.816504348007143],
                    [2.255533228883082, 48.816826056589051],
                    [2.255577447061287, 48.816686026607918],
                    [2.256476823026566, 48.817031593270052],
                    [2.256746560892636, 48.816643833286818],
                    [2.25660169654064, 48.816583572744335],
                    [2.257049158712351, 48.815956778816371],
                    [2.257614133103625, 48.816162651638528],
                    [2.258360322472335, 48.815213925410596],
                    [2.25879567893929, 48.815532312309983],
                    [2.258912271400288, 48.815473675071289],
                    [2.259680146311688, 48.814913612900831],
                    [2.259363377712408, 48.814779440129982],
                    [2.259535931168243, 48.814615919788373],
                    [2.259645592757372, 48.814661568606368],
                    [2.259934563080111, 48.81425952961937],
                    [2.260365829485524, 48.814386314775511],
                    [2.261297619756556, 48.813308304977269],
                    [2.261672123217414, 48.81340415539767],
                    [2.263938101918665, 48.814471318193128],
                    [2.264938092834417, 48.813573579318273],
                    [2.265788168976246, 48.813648955471422],
                    [2.26728101446973, 48.814016072608865],
                    [2.272560936455356, 48.814399077456102],
                    [2.274475730250409, 48.81459149026022],
                    [2.276102189282937, 48.814953910783018],
                    [2.277188994353072, 48.815343626992529],
                    [2.278070533915822, 48.814821909442514],
                    [2.278183329673125, 48.814248778184755],
                    [2.274490483935192, 48.813433161476318],
                    [2.275390682698427, 48.812744288787272],
                    [2.275957252731628, 48.812445524928179],
                    [2.277289842423617, 48.811997594976674],
                    [2.278498804557997, 48.811428385216388],
                    [2.279966260199808, 48.810973144611559],
                    [2.279911190583994, 48.810917949832636],
                    [2.278268109687356, 48.808713515475134],
                    [2.277244855155615, 48.807579488985951],
                    [2.276104767769206, 48.805252141240373],
                    [2.274344733782556, 48.803453461084978],
                    [2.27308574135416, 48.801858366411828],
                    [2.275685386324922, 48.80172304810263],
                    [2.277541383257, 48.801507631044231],
                    [2.277133036493422, 48.800910656816761],
                    [2.276676168162769, 48.800475279867555],
                    [2.276488362605867, 48.800469646181128],
                    [2.276424012147169, 48.800201234313356],
                    [2.276642602121391, 48.800146794355783],
                    [2.276474863031182, 48.799087180179889],
                    [2.27621863082782, 48.798813109134542],
                    [2.275628693023775, 48.798942647188206],
                    [2.275319664133165, 48.798255427088407],
                    [2.276375390852976, 48.797719481901744],
                    [2.271385654150762, 48.794906400861706],
                    [2.272192931339612, 48.794125236396127],
                    [2.272988895855532, 48.79083284265144],
                    [2.272319681538355, 48.79079639071665],
                    [2.271721900552649, 48.79051842856213],
                    [2.270836475388334, 48.790076814302424],
                    [2.268786147098284, 48.789324968697656],
                    [2.263902842453213, 48.788411763402181],
                    [2.258733667462367, 48.786267081673998],
                    [2.258728625725827, 48.786142930873389],
                    [2.255614734961339, 48.785166592841819],
                    [2.254254269178281, 48.784837916882111],
                    [2.252483971032067, 48.78452105272622],
                    [2.25066061952954, 48.78448804587903],
                    [2.250572116040734, 48.784679966483914],
                    [2.248391256689982, 48.782536441696479],
                    [2.246827215628888, 48.780384169957372],
                    [2.24648184304313, 48.779702927893297],
                    [2.246317644313486, 48.779104674970597],
                    [2.240277994834056, 48.779843524920622],
                    [2.239203527637806, 48.77624977934574],
                    [2.24066898855168, 48.776074720229524],
                    [2.240304314309081, 48.774763735038107],
                    [2.237680273662995, 48.776281442886621],
                    [2.237455504466116, 48.776297097547051],
                    [2.230385272022081, 48.776799511615636],
                    [2.229321411483678, 48.776315956885377],
                    [2.228911333942625, 48.775978723580302],
                    [2.228757428265271, 48.775527116508734],
                    [2.228843879378716, 48.774465449007117],
                    [2.22867989385139, 48.774512060098985],
                    [2.228636574556544, 48.774680873103215],
                    [2.22829905859771, 48.774959315224528],
                    [2.227853379329299, 48.775649895072],
                    [2.227065074665619, 48.776134985925225],
                    [2.226553884283135, 48.776101996384135]
                  ]
                ]
              ]
            }
          },
          {
            type: 'Feature',
            properties: {
              ID: 'COMMUNE_0000000009737024',
              NOM_COM: 'Le Plessis-Robinson',
              NOM_COM_M: 'PLESSIS ROBINSON',
              INSEE_COM: '92060',
              STATUT: 'Commune simple',
              INSEE_CAN: '06',
              INSEE_ARR: '1',
              INSEE_DEP: '92',
              INSEE_REG: '11',
              CODE_EPCI: '200054781',
              POPULATION: 29100,
              TYPE: 'COM'
            },
            geometry: {
              type: 'MultiPolygon',
              coordinates: [
                [
                  [
                    [2.281982973480441, 48.783182842503294],
                    [2.281799118590299, 48.782598015876452],
                    [2.280571060641436, 48.783320055138873],
                    [2.279475217603877, 48.782547148483907],
                    [2.278975645346166, 48.782750101465496],
                    [2.278274945797773, 48.782045224593375],
                    [2.278093239395738, 48.782095393698953],
                    [2.277508098695573, 48.781106094204368],
                    [2.276440342412156, 48.781356866549764],
                    [2.276284502943734, 48.78121021684661],
                    [2.276226024609285, 48.781305201020722],
                    [2.27585244671454, 48.780765084793529],
                    [2.275377528740945, 48.779486828045179],
                    [2.275061657466364, 48.779496604334412],
                    [2.274392605985353, 48.777011938515955],
                    [2.272386191725841, 48.777340616757506],
                    [2.271689136669199, 48.776971203872399],
                    [2.269887763597756, 48.776552770130635],
                    [2.269555905005916, 48.776344773623947],
                    [2.269332364022728, 48.775981838359087],
                    [2.267402910353669, 48.776451213918193],
                    [2.26725197906949, 48.776151679610436],
                    [2.267288033117276, 48.775909955695951],
                    [2.267070766827625, 48.775682867507079],
                    [2.267228735600964, 48.775287190384503],
                    [2.266386548845087, 48.775275725703622],
                    [2.265917203656938, 48.775556161383157],
                    [2.265098351860202, 48.774950311237802],
                    [2.264966331898145, 48.775048435782566],
                    [2.264732294867147, 48.774853619204798],
                    [2.264556161935374, 48.774991945927248],
                    [2.264287517677918, 48.774935426884127],
                    [2.264397251878037, 48.774680665856188],
                    [2.264310062327774, 48.77459108584339],
                    [2.26380378616833, 48.774595162403863],
                    [2.259916315965811, 48.773227399631402],
                    [2.259333835870872, 48.773136545212964],
                    [2.257220965812277, 48.773299714306049],
                    [2.256565037577113, 48.773111251509668],
                    [2.256492426283086, 48.77324121657432],
                    [2.25570731950999, 48.773237227033434],
                    [2.255714030702404, 48.773052886218089],
                    [2.25412640461748, 48.773025895008374],
                    [2.254070392522063, 48.772755716923143],
                    [2.252318685787448, 48.7725945615828],
                    [2.25129289939786, 48.772579142627691],
                    [2.2508641253931, 48.772683486511013],
                    [2.25072205640999, 48.772816610324035],
                    [2.249850855307094, 48.773027905001776],
                    [2.246471902385538, 48.773511218460811],
                    [2.246320091954513, 48.772716065425968],
                    [2.244939676301225, 48.772852156357651],
                    [2.24494716906707, 48.772804533986161],
                    [2.244420590426329, 48.772990084618733],
                    [2.243838398541419, 48.773069148322747],
                    [2.242685293017275, 48.773387437050353],
                    [2.241918158186066, 48.773832285692421],
                    [2.242058627391159, 48.773061467173093],
                    [2.240653203073, 48.773044447037819],
                    [2.239195955533968, 48.772661911956817],
                    [2.239023894157681, 48.773263433728694],
                    [2.238735988194096, 48.773223823368674],
                    [2.238499067244211, 48.773793450796276],
                    [2.238244072571361, 48.773829601094057],
                    [2.237255266230457, 48.77361012716014],
                    [2.236807367040915, 48.773716996903467],
                    [2.236486920733896, 48.774971451038581],
                    [2.237235314900264, 48.775533876999759],
                    [2.237165807560502, 48.775820350558092],
                    [2.237455504466116, 48.776297097547051],
                    [2.237680273662995, 48.776281442886621],
                    [2.240304314309081, 48.774763735038107],
                    [2.24066898855168, 48.776074720229524],
                    [2.239203527637806, 48.77624977934574],
                    [2.240277994834056, 48.779843524920622],
                    [2.246317644313486, 48.779104674970597],
                    [2.24648184304313, 48.779702927893297],
                    [2.246827215628888, 48.780384169957372],
                    [2.248391256689982, 48.782536441696479],
                    [2.250572116040734, 48.784679966483914],
                    [2.25066061952954, 48.78448804587903],
                    [2.252483971032067, 48.78452105272622],
                    [2.254254269178281, 48.784837916882111],
                    [2.255614734961339, 48.785166592841819],
                    [2.258728625725827, 48.786142930873389],
                    [2.258733667462367, 48.786267081673998],
                    [2.263902842453213, 48.788411763402181],
                    [2.268786147098284, 48.789324968697656],
                    [2.270836475388334, 48.790076814302424],
                    [2.271721900552649, 48.79051842856213],
                    [2.272025097484228, 48.789665834193016],
                    [2.272067449544311, 48.789166918032166],
                    [2.272282623322328, 48.788964061790303],
                    [2.27302678917303, 48.788406457900059],
                    [2.27353389508323, 48.788156806615724],
                    [2.274492659192621, 48.787924286817251],
                    [2.274965565248343, 48.787686114158156],
                    [2.274824269794296, 48.78756923236358],
                    [2.273993290899463, 48.787716187539232],
                    [2.273828652141533, 48.786733925996927],
                    [2.273982032103238, 48.786373293189868],
                    [2.274764875273899, 48.785770941761591],
                    [2.275605360385358, 48.785917248221622],
                    [2.275950576215922, 48.78605155456178],
                    [2.276607907269483, 48.786057334617894],
                    [2.277250289427032, 48.785963185570132],
                    [2.278421030209807, 48.785653666996403],
                    [2.280190662153742, 48.785539321608773],
                    [2.280151213171646, 48.785044405544092],
                    [2.279097066633943, 48.785191850385509],
                    [2.278753298611939, 48.784263377504161],
                    [2.279477589357958, 48.784050987924914],
                    [2.279532717084509, 48.784099888821238],
                    [2.279915462539166, 48.784078811209767],
                    [2.280801547812407, 48.783878181553803],
                    [2.280877150011106, 48.783527864155573],
                    [2.281319859537486, 48.783401911194694],
                    [2.281890083849051, 48.783405339611271],
                    [2.281853105144182, 48.783224334608335],
                    [2.281982973480441, 48.783182842503294]
                  ]
                ]
              ]
            }
          }
        ]
      },
      minified: `{
        "type": "Polygon",
        "coordinates": [
          [
            [2.319077366036552, 48.81000521415452],
            [2.325557826171094, 48.80958056171101],
            [2.332461042459754, 48.81824713007446],
            [2.301315418488453, 48.825125760833096],
            [2.292019146976302, 48.81819168822453],
            [2.285265146391211, 48.81561972433184],
            [2.261297619756556, 48.81330830497727],
            [2.256476823026566, 48.81703159327005],
            [2.252066775485944, 48.815999465424284],
            [2.255000924005436, 48.81013933241046],
            [2.248251771888092, 48.80393258532117],
            [2.242345580712239, 48.803442894940204],
            [2.234789457571507, 48.79542509898711],
            [2.236455431156926, 48.78902922465098],
            [2.234847092981064, 48.7845344341781],
            [2.223689756055463, 48.780645312410726],
            [2.224953163064658, 48.77667625079608],
            [2.230740828929338, 48.773266147353695],
            [2.232974391836455, 48.76619298033995],
            [2.238586808776485, 48.766473535597356],
            [2.247008759135448, 48.76082360270587],
            [2.25501234202061, 48.76139007238169],
            [2.26200189885993, 48.759788397169345],
            [2.267167187774805, 48.76232333338605],
            [2.271415402350211, 48.75778288733411],
            [2.279639381213194, 48.75300818726111],
            [2.285358224042771, 48.7475127784516],
            [2.276953514875232, 48.74166883625485],
            [2.275359785249413, 48.73842564614056],
            [2.279883437612638, 48.73274868093385],
            [2.299644793662199, 48.73918581249464],
            [2.303840060837942, 48.72948996496163],
            [2.314442400735643, 48.730421106182504],
            [2.318718087902937, 48.73701878099306],
            [2.31434409938316, 48.74329616469351],
            [2.32072071416347, 48.74875804930149],
            [2.308693502687006, 48.755409625559366],
            [2.313385255497475, 48.760160518515335],
            [2.315102913544004, 48.765698273897144],
            [2.320558853276971, 48.771440778814046],
            [2.324580300699613, 48.77907446536476],
            [2.325119460401384, 48.78631688599155],
            [2.318696264868557, 48.78799740955943],
            [2.323994804403164, 48.805361673506134],
            [2.31833553487429, 48.8060229694341],
            [2.319077366036552, 48.81000521415452]
          ]
        ]
      }`
    }
  };
  return isochrones[process.env.VUE_APP_PROJECT];
};
